/**
 * Constants defining the valid range for sequence IDs according to Bambu Lab protocol
 */
export const START_SEQ_ID = 20000;
export const END_SEQ_ID = 30000;
export const PROJECT_FILE_SEQUENCE_ID = 50000;

let sequenceId: number = START_SEQ_ID;

/**
 * Gets the next valid sequence ID for printer commands.
 * Implements proper wraparound handling to stay within the valid range (20000-30000).
 * 
 * @returns A unique sequence ID within the valid range
 */
export function getSequenceId(): number {
    sequenceId++;
    if (sequenceId >= END_SEQ_ID) {
        sequenceId = START_SEQ_ID;
    }
    return sequenceId;
}

/**
 * Validates if a sequence ID is within the valid range for Bambu Lab protocol
 * 
 * @param id - The sequence ID to validate
 * @returns boolean indicating if the ID is valid
 */
export function isValidSequenceId(id: number): boolean {
    return id >= START_SEQ_ID && id < END_SEQ_ID;
}
